import moment from "moment";
import { Link } from "react-router-dom";
import { ROUTE_FILE_LIST_CONFIGURATION } from "../../../core/route/ui.routes";
import { ReactComponent as EyeIcon } from "../../../assets/icons/eye-icon.svg";
export const annoucementStatuses = {
  SCHEDULED: 'Scheduled',
  ACTIVE: 'Active',
  STOPPED: 'Stopped',
  EXPIRED: 'Expired',
}

const getIframeUrl = (url:string) => {
  if(!url.includes('iframe')){
    return url
  }
  var parser = new DOMParser();

  var parsedIframe = parser.parseFromString(url, "text/html");
  let iFrame = parsedIframe.getElementsByTagName("iframe");

  // Read URL:
  let src = iFrame?.[0]?.src;
  return src || url;
}

export const annoucementConfigColumns = (actions:any) => [
  {
    title: "S. No.",
    key: "sno",
    render: (_: any) => _.sno,
    width: "90px",
  },
  {
    title: "Announcement Name",
    key: "announcement_name",
    dataIndex: "announcement_name",
  },
  {
    title: "Announcement Category",
    key: "announcement_category",
    dataIndex: "announcement_category",
  },
  {
    title: "Content",
    key: "content",
    // dataIndex: "announcement_ref",
    render: (rec: any) => rec?.announcement_type =='video' ? 
    <a target="_blank" href={getIframeUrl(rec?.announcement_ref)}>{rec?.announcement_name}.mp4</a>:
    <a target="_blank" href={rec?.ref_url}>{rec?.filename}</a>,
  },
  {
    title: "Visibility Date Range",
    key: "date_range",
    // dataIndex: "date_range",
    render: (rec:any)=>`${moment(rec?.start_date).format("DD MMM'YY")} to ${moment(rec?.end_date).format("DD MMM'YY")}`
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "Created By",
    key: "created_by",
    dataIndex: "created_by",
  },
  {
    title: "Actions",
    key: "actions",
    render: (rec: any) => actions(rec),
  },
];

export const annoucementConfigFilterForm = [
  {
    type: "Input",
    name: "searchTerm",
    placeholder: "Search Announcement Name",
    colSpan: 10,
    allowClear: true,
  },
  {
    type: "Select",
    name: "status",
    colSpan: 6,
    placeholder: "All Status",
    options: [
      "Scheduled", "Active","Stopped","Expired"
    ]?.map((val:any)=>{
      return {value: val, name: val}
    }),
    allowClear: true,
  },
  {
    type: "RangePicker",
    name: "range",
    colSpan: 8,
    allowClear: true,
    disabledDate: ()=>{}
  },
];

export const audienceConfigColumns = (onEditAudience: any, onViewAudienceQuery: any) => [
  {
    title: "S. No.",
    key: "sno",
    render: (_: any, __: any, index: any) => _.sno,
    width: "90px",
  },
  {
    title: "Audience Name",
    key: "audience_name",
    render: (rec: any) => rec?.audience_name,
  },
  {
    title: "Audience Size",
    key: "audience_size",
    dataIndex: "audience_count",
  },
  {
    title: "No. of Announcements",
    key: "announcements",
    dataIndex: "announcement_count",
  },
  {
    title: "Condition/CSV File",
    key: "c_file",
    render: (rec: any) => (
      <>
        {rec?.audience_type == "query" ? (
          <a onClick={() => onViewAudienceQuery(rec)}><EyeIcon /></a> //rec.query_sql
        ) : (
          <a href={rec?.csv_url} target="_blank">
            {rec?.filename || rec?.csv_ref}
          </a>
        )}
      </>
    ),
  },
  {
    title: "Created By",
    key: "created_by",
    dataIndex: "created_by",
  },
  {
    title: "Actions",
    key: "actions",
    render: (rec: any) => (
      <>
        { typeof rec?.announcement_count == 'number' && rec?.announcement_count == 0 ? <a onClick={() => onEditAudience(rec)}>
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.8 6.925L12.55 2.725L13.95 1.325C14.3333 0.941667 14.8043 0.75 15.363 0.75C15.921 0.75 16.3917 0.941667 16.775 1.325L18.175 2.725C18.5583 3.10833 18.7583 3.571 18.775 4.113C18.7917 4.65433 18.6083 5.11667 18.225 5.5L16.8 6.925ZM15.35 8.4L4.75 19H0.5V14.75L11.1 4.15L15.35 8.4Z"
              fill="#4DA9D0"
            />
          </svg>
        </a> : <>
          {/* <a onClick={() => onEditAudience(rec)}><EyeIcon /></a> */}
        </> }
      </>
    ),
  },
];

export const audienceConfigFilterForm = [
  {
    type: "Input",
    name: "searchTerm",
    placeholder: "Search Audience Name",
    colSpan: 10,
    allowClear: true,
  },
];

export const annoucementTableConfigs = {
  annoucement: {
    columns: annoucementConfigColumns,
    filterForm: annoucementConfigFilterForm,
  },
  audience: {
    columns: audienceConfigColumns,
    filterForm: audienceConfigFilterForm,
  },
};
